const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const GENERIC_INGREDIENT_ENDPOINTS = {
  BASE: `${API_URL}/generic-ingredients`,
  GET_BY_IDS: (ids: number[]) => `${API_URL}/generic-ingredients?ids=${ids.join(",")}`,
} as const;

export default GENERIC_INGREDIENT_ENDPOINTS;
